(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-gw-cookie-jar]';
  var TAB_SELECTOR = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function safeStorageGet(key) {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  }

  function safeStorageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (error) {}
  }

  function monthDetails(timeZone) {
    var now = new Date();
    var month = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      year: 'numeric',
      timeZone: timeZone || 'America/New_York'
    }).format(now);
    var parts = new Intl.DateTimeFormat('en-CA', {
      year: 'numeric',
      month: '2-digit',
      timeZone: timeZone || 'America/New_York'
    }).formatToParts(now);
    var year = parts.find(function (part) { return part.type === 'year'; });
    var numericMonth = parts.find(function (part) { return part.type === 'month'; });
    return {
      label: month,
      key: year && numericMonth ? year.value + '-' + numericMonth.value : month
    };
  }

  function responseError(response) {
    return response.json().then(function (json) {
      var detail = json && json.errors && json.errors[0] && json.errors[0].detail;
      return detail || 'Something went wrong. Please try again.';
    }).catch(function () {
      return 'Something went wrong. Please try again.';
    });
  }

  function postJson(url, revision, payload, retries) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'revision': revision
      },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (response) {
      if (response.ok || response.status === 202) return response;
      if (retries > 0 && response.status >= 500) {
        return postJson(url, revision, payload, retries - 1);
      }
      return responseError(response).then(function (message) {
        throw new Error(message);
      });
    }).catch(function (error) {
      if (retries > 0 && (!error || !error.message || error.message === 'Failed to fetch')) {
        return postJson(url, revision, payload, retries - 1);
      }
      throw error;
    });
  }

  function init(root) {
    if (!root || root.dataset.gwCookieJarInitialized === 'true') return;
    root.dataset.gwCookieJarInitialized = 'true';

    var openButton = root.querySelector('[data-gw-cookie-jar-open]');
    var template = root.querySelector('template[data-gw-cookie-jar-template]');
    if (!openButton || !template) return;

    var companyId = root.dataset.klaviyoCompanyId || '';
    var listId = root.dataset.klaviyoListId || '';
    var eventName = root.dataset.eventName || 'Cookie Jar Entry Submitted';
    var sourceLabel = root.dataset.sourceLabel || 'Cookie Jar';
    var timeZone = root.dataset.timeZone || 'America/New_York';
    var delay = Math.max(0, Number(root.dataset.delaySeconds || 12) * 1000);
    var designMode = root.dataset.designMode === 'true';
    var previewOverride = new URLSearchParams(window.location.search).get('gw_cookie_jar_preview') === '1';
    var month = monthDetails(timeZone);
    var enteredKey = 'gw_cookie_jar_entered_month';
    var activeBackdrop = null;
    var lastFocused = null;

    function eligible() {
      if (designMode || previewOverride) return true;
      if (safeStorageGet(enteredKey) === month.key) return false;
      return true;
    }

    function showTeaser() {
      if (eligible()) root.classList.add('is-ready');
    }

    function minimize() {
      root.classList.add('is-minimized');
      closeDialog(true);
    }

    function getFocusable() {
      if (!activeBackdrop) return [];
      return Array.prototype.slice.call(activeBackdrop.querySelectorAll(TAB_SELECTOR)).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function handleKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        minimize();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function closeDialog(restoreFocus) {
      if (!activeBackdrop) return;
      document.removeEventListener('keydown', handleKeydown);
      activeBackdrop.remove();
      activeBackdrop = null;
      root.classList.remove('is-dialog-open');
      document.body.classList.remove('gw-cookie-jar-locked');
      if (restoreFocus !== false && lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function showSuccess(backdrop, guess) {
      var entry = backdrop.querySelector('[data-gw-cookie-jar-entry]');
      var success = backdrop.querySelector('[data-gw-cookie-jar-success]');
      var guessOutput = backdrop.querySelector('[data-gw-cookie-jar-guess-output]');
      var monthOutput = backdrop.querySelector('[data-gw-cookie-jar-month-output]');
      if (entry) entry.hidden = true;
      if (success) success.hidden = false;
      if (guessOutput) guessOutput.textContent = guess;
      if (monthOutput) monthOutput.textContent = month.label;
      safeStorageSet(enteredKey, month.key);
      root.classList.remove('is-ready');
      var successTitle = backdrop.querySelector('[data-gw-cookie-jar-success-title]');
      if (successTitle) successTitle.focus();
    }

    function trackSuccess(email, firstName, guess) {
      try {
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', {
          '$email': email,
          '$first_name': firstName,
          '$source': sourceLabel,
          'cookie_jar_guess': Number(guess),
          'cookie_jar_month': month.label
        }]);
      } catch (error) {}

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'cookie_jar_entry_submitted',
          cookie_jar_month: month.label,
          cookie_jar_guess: Number(guess)
        });
      } catch (error) {}

      try {
        if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Cookie Jar Contest' });
      } catch (error) {}
    }

    function wireDialog(backdrop) {
      var form = backdrop.querySelector('[data-gw-cookie-jar-form]');
      var closeButtons = backdrop.querySelectorAll('[data-gw-cookie-jar-close]');
      var errorBox = backdrop.querySelector('[data-gw-cookie-jar-error]');
      var submitButton = form && form.querySelector('button[type="submit"]');
      var submitLabel = submitButton && submitButton.querySelector('[data-gw-cookie-jar-submit-label]');
      var originalSubmitLabel = submitLabel ? submitLabel.textContent : '';
      var copyButton = backdrop.querySelector('[data-gw-cookie-jar-copy]');

      closeButtons.forEach(function (button) {
        button.addEventListener('click', minimize);
      });

      if (copyButton) {
        copyButton.addEventListener('click', function () {
          var code = copyButton.dataset.code || '';
          if (!code || !navigator.clipboard) return;
          navigator.clipboard.writeText(code).then(function () {
            copyButton.textContent = 'Copied';
          }).catch(function () {});
        });
      }

      if (!form) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!form.reportValidity()) return;

        var formData = new FormData(form);
        var firstName = String(formData.get('first_name') || '').trim();
        var email = String(formData.get('email') || '').trim().toLowerCase();
        var guess = String(formData.get('guess') || '').trim();
        var numericGuess = Number(guess);

        if (!firstName || !email || !Number.isInteger(numericGuess) || numericGuess < 1 || numericGuess > 9999) {
          if (errorBox) {
            errorBox.textContent = 'Please enter your first name, a valid email, and a whole-number guess between 1 and 9,999.';
            errorBox.hidden = false;
          }
          return;
        }

        if (!companyId || !listId) {
          if (errorBox) {
            errorBox.textContent = 'This contest form is not configured yet. Please try again later.';
            errorBox.hidden = false;
          }
          return;
        }

        if (errorBox) errorBox.hidden = true;
        if (submitButton) submitButton.disabled = true;
        if (submitLabel) submitLabel.textContent = 'Locking in your guess…';

        var profileProperties = {
          cookie_jar_guess: numericGuess,
          cookie_jar_month: month.label,
          signup_source: sourceLabel
        };

        var subscriptionPayload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: sourceLabel,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: firstName,
                    properties: profileProperties,
                    subscriptions: {
                      email: { marketing: { consent: 'SUBSCRIBED' } }
                    }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        };

        var eventId = window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : 'cookie-jar-' + Date.now() + '-' + Math.random().toString(36).slice(2);

        var eventPayload = {
          data: {
            type: 'event',
            attributes: {
              unique_id: eventId,
              time: new Date().toISOString(),
              properties: {
                guess: numericGuess,
                month: month.label,
                source: sourceLabel
              },
              metric: {
                data: { type: 'metric', attributes: { name: eventName } }
              },
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email, first_name: firstName }
                }
              }
            }
          }
        };

        var baseUrl = 'https://a.klaviyo.com/client/';
        var companyQuery = '?company_id=' + encodeURIComponent(companyId);

        Promise.all([
          postJson(baseUrl + 'subscriptions/' + companyQuery, '2026-07-15', subscriptionPayload, 1),
          postJson(baseUrl + 'events/' + companyQuery, '2026-04-15', eventPayload, 1)
        ]).then(function () {
          form.reset();
          showSuccess(backdrop, numericGuess.toLocaleString());
          trackSuccess(email, firstName, numericGuess);
        }).catch(function (error) {
          if (submitButton) submitButton.disabled = false;
          if (submitLabel) submitLabel.textContent = originalSubmitLabel;
          if (errorBox) {
            errorBox.textContent = error && error.message ? error.message : 'We could not save your entry. Please try again.';
            errorBox.hidden = false;
          }
        });
      });
    }

    function openDialog() {
      if (activeBackdrop) return;
      lastFocused = document.activeElement;
      var fragment = template.content.cloneNode(true);
      activeBackdrop = fragment.querySelector('[data-gw-cookie-jar-backdrop]');
      if (!activeBackdrop) return;
      wireDialog(activeBackdrop);
      document.body.appendChild(activeBackdrop);
      root.classList.add('is-dialog-open');
      document.body.classList.add('gw-cookie-jar-locked');
      document.addEventListener('keydown', handleKeydown);
      window.requestAnimationFrame(function () {
        var firstInput = activeBackdrop && activeBackdrop.querySelector('input');
        if (firstInput) firstInput.focus();
      });
    }

    openButton.addEventListener('click', openDialog);

    if (designMode || previewOverride || delay === 0) showTeaser();
    else window.setTimeout(showTeaser, delay);

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.contains(root)) showTeaser();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
